export default __webpack_public_path__ + "static/media/GaryWu_headshot.6cced58e.png";